import {Title} from './title';
import {VotableModel} from '@common/votes/votable-model';
import {Episode} from '@app/titles/models/episode';

export const QUAL_MODEL_TYPE = 'quality';

const qualitiesArray = [
  { id_qual: 1, qual: "DVDRIP" },
  { id_qual: 2, qual: "BDRIP" },
  { id_qual: 3, qual: "BRRIP" },
  { id_qual: 4, qual: "WEB-SD" },
  { id_qual: 5, qual: "TS" },
  { id_qual: 6, qual: "CAM" },
  { id_qual: 7, qual: "DVDSCR" },
  { id_qual: 8, qual: "R5" },
  { id_qual: 9, qual: "R6" },
  { id_qual: 10, qual: "DVD-R" },
  { id_qual: 11, qual: "Full-DVD" },
  { id_qual: 12, qual: "IMG" },
  { id_qual: 13, qual: "ISO" },
  { id_qual: 14, qual: "HDTV" },
  { id_qual: 15, qual: "HDRip" },
  { id_qual: 16, qual: "Blu-Ray 720p" },
  { id_qual: 17, qual: "Blu-Ray 1080p" },
  { id_qual: 18, qual: "Blu-Ray 3D" },
  { id_qual: 19, qual: "PDTV" },
  { id_qual: 20, qual: "TVrip" },
  { id_qual: 21, qual: "TeleCine (TC)" },
  { id_qual: 22, qual: "EXE" },
  { id_qual: 23, qual: "MP3" },
  { id_qual: 24, qual: "FLAC" },
  { id_qual: 25, qual: "M4A" },
  { id_qual: 26, qual: "PDF" },
  { id_qual: 27, qual: "Autre" },
  { id_qual: 28, qual: "CBR" },
  { id_qual: 29, qual: "CBZ" },
  { id_qual: 30, qual: "IPA" },
  { id_qual: 31, qual: "HD 720p" },
  { id_qual: 32, qual: "DVDRIP MD" },
  { id_qual: 33, qual: "DVDRIP LD" },
  { id_qual: 34, qual: "BDRIP MD" },
  { id_qual: 35, qual: "BDRIP LD" },
  { id_qual: 36, qual: "BRRIP MD" },
  { id_qual: 37, qual: "BRRIP LD" },
  { id_qual: 38, qual: "DVDSCR MD" },
  { id_qual: 39, qual: "DVDSCR LD" },
  { id_qual: 40, qual: "R5 MD" },
  { id_qual: 41, qual: "TS MD" },
  { id_qual: 42, qual: "TS LD" },
  { id_qual: 44, qual: "HDRiP MD" },
  { id_qual: 45, qual: "HDTS MD" },
  { id_qual: 46, qual: "CAM MD" },
  { id_qual: 47, qual: "HDCAM" },
  { id_qual: 48, qual: "TC" },
  { id_qual: 49, qual: "HDLight 720p" },
  { id_qual: 50, qual: "HDLight 1080p" },
  { id_qual: 51, qual: "DVDRIP MKV" },
  { id_qual: 52, qual: "HD 1080p" },
  { id_qual: 53, qual: "ULTRA HD (x265)" },
  { id_qual: 54, qual: "WEB-DL 720p" },
  { id_qual: 55, qual: "WEB-DL 1080p" },
  { id_qual: 56, qual: "ARCHIVE" },
  { id_qual: 57, qual: "REMUX" },
  { id_qual: 58, qual: "epub" },
  { id_qual: 59, qual: "PKG" },
  { id_qual: 60, qual: "Ultra HDLight (x265)" },
  { id_qual: 61, qual: "HDTV 720p" },
  { id_qual: 62, qual: "HDTV 1080p" },
  { id_qual: 64, qual: "XCI" },
  { id_qual: 71, qual: "NSP" },
  { id_qual: 76, qual: "Blu-Ray 1080p (x265)" },
  { id_qual: 83, qual: "WEB-DL 1080p (x265)" },
  { id_qual: 86, qual: "HDLight 1080p (x265)" }
];
export {qualitiesArray};



